import { render, staticRenderFns } from "./grupi2.vue?vue&type=template&id=037aa446&scoped=true&"
import script from "./grupi2.vue?vue&type=script&lang=js&"
export * from "./grupi2.vue?vue&type=script&lang=js&"
import style0 from "./grupi2.vue?vue&type=style&index=0&id=037aa446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037aa446",
  null
  
)

export default component.exports